import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 19v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2","key":"svg-0"}],["path",{"d":"M11 15h2","key":"svg-1"}],["path",{"d":"M9 12h6","key":"svg-2"}],["path",{"d":"M10 9h4","key":"svg-3"}]]

const IconAlignBoxCenterMiddle = createReactComponent('outline', 'align-box-center-middle', 'AlignBoxCenterMiddle', __iconNode);

export default IconAlignBoxCenterMiddle;